/* eslint-disable jsx-a11y/no-noninteractive-element-to-interactive-role */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import * as React from "react";
import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";

import {
  toggleBackgroundAudio,
  toggleAudioEffects,
} from "../../../../store/audio-slice";
import { useAppDispatch, useAppSelector } from "../../../../store/hooks";

import dropdownMenuCaret from "../../../../assets/img/audio/caret.svg";
import dropdownMenuCheckMark from "../../../../assets/img/audio/check_mark.svg";

const AudioVolumeCaret: React.FC = () => {
  const caretElement = useRef<HTMLButtonElement>(null);
  const isBackgroundAudioEnabled = useAppSelector(
    (state) => state.audio.isBackgroundAudioEnabled
  );
  const areAudioEffectsEnabled = useAppSelector(
    (state) => state.audio.areAudioEffectsEnabled
  );
  const [isDropdownMenu, setIsDropdownMenu] = useState(false);
  const dispatch = useAppDispatch();
  const { t } = useTranslation();

  const dropdownMenuClickHandler = (): void => {
    setIsDropdownMenu((prevState) => !prevState);
  };

  const outsideDropdownMenuClickHandler = (event: Event): void => {
    if (
      caretElement.current &&
      !caretElement.current.contains(event.target as Node)
    ) {
      setIsDropdownMenu(false);
    }
  };

  useEffect(() => {
    document.addEventListener("click", outsideDropdownMenuClickHandler, true);
    return () => {
      document.removeEventListener(
        "click",
        outsideDropdownMenuClickHandler,
        true
      );
    };
  }, []);

  return (
    <button
      ref={caretElement}
      type="button"
      className="sound_settings"
      onClick={dropdownMenuClickHandler}
    >
      <div className="carrot">
        <img src={dropdownMenuCaret} alt="" />

        {isDropdownMenu && (
          <ul className="dropdown-content show">
            <li
              role="button"
              tabIndex={-1}
              onClick={() => dispatch(toggleBackgroundAudio())}
            >
              {t("panel.common.backgroundMusic")}
              {isBackgroundAudioEnabled && (
                <img src={dropdownMenuCheckMark} alt="" />
              )}
            </li>
            <li
              role="button"
              tabIndex={-1}
              onClick={() => dispatch(toggleAudioEffects())}
            >
              {t("panel.common.soundEffects")}
              {areAudioEffectsEnabled && (
                <img src={dropdownMenuCheckMark} alt="" />
              )}
            </li>
          </ul>
        )}
      </div>
    </button>
  );
};

export default AudioVolumeCaret;
